/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type GroomingLocationTypeEnum =
  (typeof GroomingLocationTypeEnum)[keyof typeof GroomingLocationTypeEnum];

export const GroomingLocationTypeEnum = {
  bathroom: 'bathroom',
  kitchen: 'kitchen',
  pet_wash_area: 'pet_wash_area',
  other: 'other',
} as const;
